import { NextPage } from "next";

import Container from "@mui/material/Container";

import InfoMission from "sections/aboutPage/InfoMission";
import InfoServices from "sections/aboutPage/InfoServices";

import Layout from "components/Layout";

const AboutPage: NextPage = () => {
  return (
    <Layout
      subHeader={{
        header: "WHY UNIQLY?",
        description:
          "To deeply understand the idea behind Uniqly, check our Mission, Vision and wider perspective of the ecosystem.",
        background: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/subheader/about.jpg`,
        isBackgroundGradient: true,
      }}
    >
      <Container>
        <InfoServices />
        <InfoMission />
      </Container>
    </Layout>
  );
};

export default AboutPage;
